import type { GalleryKind } from '../api/chats';
import type { MediaItem, MessageDto } from '../api/types';

export function mediaMatchesTab(m: MediaItem, tab: GalleryKind): boolean {
  if (tab === 'media') return m.kind === 'image' || m.kind === 'video';
  if (tab === 'music') return m.kind === 'audio' && !!m.fileName;
  if (tab === 'voice') return (m.kind === 'audio' || m.kind === 'video') && !m.fileName;
  if (tab === 'file') return m.kind === 'file';
  return false;
}

export function galleryItems(msg: MessageDto, tab: GalleryKind): MediaItem[] {
  // Метаданные сервера учитывают видео-документы и не зависят от kind внутри payload.
  if (tab === 'media' && msg.galleryMedia != null) {
    return msg.galleryMedia.flatMap((file) => {
      const mime = file.mimeType.toLowerCase();
      const kind = mime.startsWith('video/') ? 'video' : mime.startsWith('image/') ? 'image' : null;
      const original = msg.payload.data?.media?.find((media) => media.fileId === file.id);
      const fileName = original?.kind === 'video' ? original.fileName : file.fileName;
      return kind ? [{ fileId: file.id, kind, fileName, sizeBytes: file.sizeBytes }] : [];
    });
  }
  return (msg.payload.data?.media ?? []).filter((media) => mediaMatchesTab(media, tab));
}
